"use strict";

// eslint-disable-next-line no-unused-vars
function onPremiumLoaded() {
  let initInstagramTryCounts = 0;
  function initInstagram() {
    if (initInstagramTryCounts < 5) {
      initInstagramTryCounts += 1;
      try {
        if (window.instgrm) {
          window.instgrm.Embeds.process();
        } else {
          setTimeout(() => {
            initInstagram();
          }, 500);
        }
      } catch (e) {
        console.error(`[PREMIUM ARTICLE CONTENT] Instagram embed did not init because of ${e}`);
        setTimeout(() => {
          initInstagram();
        }, 1000);
      }
    } else {
      console.error('[PREMIUM ARTICLE CONTENT] `window.instgrm` variable not found so instagram embeds cannot be processed. ' + 'Check if `www.instagram.com/embed.js` script is included!');
    }
  }

  /**
   * Scripts are initialized in this way
   * so that a separate initialization method
   * does not have to be written for each one,
   * and in this way, all scripts that could be found
   * in the article in the future are included.
   *
   * Except for Instagram.
   * He is a 'special sausage',
   * so a special initialization goes for him.
   */
  const articleContent = document.querySelector('.js_premiumArticle');
  const contentScripts = [...articleContent.querySelectorAll('script')].filter(e => e.dataset.scriptType !== 'internal');
  contentScripts.forEach(script => {
    const scriptAttributes = script.attributes;
    const newScript = document.createElement('script');
    [...scriptAttributes].forEach(attribute => {
      newScript.setAttribute(attribute.name, attribute.value);
    });
    if (script.text) newScript.text = script.text;
    script.replaceWith(newScript);
    if (newScript.src.includes('instagram')) initInstagram();
  });
  document.dispatchEvent(new Event('PremiumArticleContentLoaded'));
}